import React from 'react';
import Table from 'react-bootstrap/Table';
import CcsdChangesRow from './CcsdChangesRow';

function CcsdChangesTable({ ccsdChanges, onCheck, onUncheck, onDelete }) {
  return (
    <Table striped hover responsive size="sm" className="mb-0">
      <thead>
        <tr>
          <th>When/Who</th>
          <th>Code</th>
          <th>Fee</th>
          <th>Effective From</th>
          <th>Applies To</th>
          <th>Fee Type</th>
          <th>Checked At/By</th>
          <th>Checked</th>
          {onDelete && <th aria-label="Delete" />}
        </tr>
      </thead>
      <tbody>
        {ccsdChanges.map((datedCost) => (
          <CcsdChangesRow
            key={datedCost.id}
            datedCost={datedCost}
            onCheck={onCheck}
            onUncheck={onUncheck}
            onDelete={onDelete}
          />
        ))}
      </tbody>
    </Table>
  );
}

export default CcsdChangesTable;
